import { render, staticRenderFns } from "./Sku.vue?vue&type=template&id=840da0e4&scoped=true"
import script from "./Sku.vue?vue&type=script&lang=js"
export * from "./Sku.vue?vue&type=script&lang=js"
import style0 from "./Sku.vue?vue&type=style&index=0&id=840da0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840da0e4",
  null
  
)

export default component.exports